import React from 'react'

function Spinner() {
  return (
    <div className=' w-full flex items-center justify-center text-center h-[80vh]'>
        <span className='loader'></span>
    </div>
  )
}

export default Spinner